import ModifyRuleSensorModal from './ModifyRuleSensorModal';
export default ModifyRuleSensorModal;
